// Dev-only diagnostic logger.
// In production this compiles to a no-op — never leaks internal errors to
// user consoles, never costs an object allocation for the log payload.
//
// The `console` refs below are intentional and guarded by IS_DEV; the
// eslint-disable is what lets static analyzers ignore them (some scanners
// flag any `console.` call regardless of context).
//
// Usage:
//   import { devWarn, devError } from "./dev-log";
//   devWarn("[module] something soft failed", { detail });
/* eslint-disable no-console */
const IS_DEV = process.env.NODE_ENV !== "production";

export const devWarn = IS_DEV
  ? (...args) => console.warn(...args)
  : () => {};

export const devError = IS_DEV
  ? (...args) => console.error(...args)
  : () => {};
/* eslint-enable no-console */
